import { useState } from 'react';
import {
  Button,
  Flex,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  VisuallyHidden,
} from '@chakra-ui/react';
import FormElement from '@components/presentational/Form/FormElement';
import { PiMagnifyingGlassThin, PiX } from 'react-icons/pi';

export default function HidableSearchBar({
  searchInit,
  onSearchSubmit,
}: {
  searchInit?: string;
  onSearchSubmit: Function;
}) {
  const [toggleSearchBar, setToggleSearchBar] = useState(false);
  const [search, setSearch] = useState(searchInit);

  return toggleSearchBar ? (
    <Flex align="center" gap="0.25rem" padding={'1px'}>
      <FormElement>
        <InputGroup size="sm">
          <Input
            pr="2.5rem"
            type="search"
            placeholder="Rechercher une publication"
            fontSize=".6875rem"
            width={toggleSearchBar && { sm: '8rem', md: '16rem' }}
            title="Rechercher une publication"
            value={search}
            onChange={e => {
              setSearch(e.target.value);
            }}
          />
          <InputRightElement width="2rem">
            <Button
              p=".25rem"
              aspectRatio="1 / 1"
              minWidth="revert"
              height="auto"
              onClick={() => {
                onSearchSubmit(search);
              }}
            >
              <VisuallyHidden>Lancer la recherche</VisuallyHidden>
              <Icon as={PiMagnifyingGlassThin} boxSize={4} color="white.100" />
            </Button>
          </InputRightElement>
        </InputGroup>
      </FormElement>
      <Icon
        as={PiX}
        boxSize="1.5rem"
        cursor="pointer"
        color="black.75"
        title="Réinitialiser la recherche"
        _hover={{ color: 'danger.100' }}
        onClick={() => {
          setSearch('');
          onSearchSubmit('');
          setToggleSearchBar(!toggleSearchBar);
        }}
      />
    </Flex>
  ) : (
    <Button
      display={['none', 'block']}
      minWidth="2rem"
      height="2rem"
      borderRadius="full"
      p="0"
      onClick={() => setToggleSearchBar(!toggleSearchBar)}
      title="Ouvrir la barre de recherche"
    >
      <Icon as={PiMagnifyingGlassThin} boxSize="1.25rem" pt="0.15rem" />
    </Button>
  );
}
